import * as React from "react";
import PropTypes from 'prop-types';
import ShowFormattedDate from './ShowFormattedDate';

const CustomDateField = ({ className, source, record = {} }) => {
    return ( <ShowFormattedDate className={className} date={record[source]} /> );
}

CustomDateField.propTypes = {
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
    label: PropTypes.string,
    className: PropTypes.string,
};

export default CustomDateField;